export default __webpack_public_path__ + "static/media/Sway_128x128.4c9bc2ff.webp";